{
	"default": {
		"logout": "Déconnexion",
		"changeLanguage": "Changer la langue",
		"changeSystemLanguage": "Changer la langue du système",
		"changeLayout": "Changer le layout"
	},
	"selectLanguageModal": {
		"selectLanguage": "Sélectonnez la langue",
		"cancel": "Annuler",
		"confirm": "Confirmer"
	},
	"event": {
		"barReports": "Rapports Bar",
		"salesReport": "Rapports de ventes",
		"bookings": "Réservations",
		"clientArea": "Hub de Données",
		"clients": "Information Clients",
		"conference": "Conférence d'événement",
		"financialReport": "Rapports financiers",
		"guestList": "Listes d'invités",
		"multivendor": "Multi-vendeur",
		"panel": "Panneau",
		"businessIntelligence": "Panneau général",
		"eventPanel": "Tableau de bord des événements",
		"reports": "Rapports",
		"customers": "Clients",
		"devices": "Dispositifs",
		"sellChip": "Ventes sans carte",
		"ticketsReport": "Rapports Ticket",
		"zigTag": "Carte ZIG",
		"operationReport": "Rapport d'Opération",
		"hawkersReport": "Rapport sur les ambulants",
		"rechargeManagement": "Gestion du solde",
		"tableReports": "Rapports de tables"
	},
	"org": {
		"panel": "Lieux",
		"employee": "Accès équipe",
		"crm": "CRM",
		"categories": "Catégories",
		"reports": "Rapports",
		"recharge": "Recharge",
		"stock": "Stock",
		"giftback": "Giftback",
		"fiscal": "Fiscal",
		"internalSalesCampaign": "Campagne de vente interne",
		"taxRegistration": "Enregistrement Fiscal",
		"stockInventory": "Enregistrement de la base de produits",
		"productRegistration": "Enregistrement de base de produit",
		"clientArea": "Hub de Données",
		"customersList": "Liste des Clients",
		"taxData": "Données fiscales",
		"fiscalSettings": "Données fiscales",
		"financialReport": "Rapports",
		"satisfactionSurvey": "Questionnaire de satisfaction",
		"customers": "Espace client",
		"sendingMessages": "Envoi de messages",
		"loyalty": "Programmes de fidélisation",
		"communication": "Campagnes de Communication",
		"chartOfAccounts": "Tableau des Comptes",
		"fiscalBoard": "Tableau fiscal",
		"vendors": "Fournisseurs",
		"team": "Équipe",
		"integrations": "Intégrations",
		"settings": "Paramètres",
		"catering": "Catering"
	},
	"place": {
		"audits": "Audits",
		"barReports": "Rapports Bar",
		"salesReport": "Rapports de ventes",
		"prechargeReports": "Précharger par feuille de calcul",
		"businessInteligence": "Business Intelligence",
		"pdvTeam": "Opérateurs de PDV",
		"productAndMenu": "Produits et menus",
		"cashFlow": "Financier",
		"clientArea": "Hub de Données",
		"clients": "Clients",
		"contracts": "Contrats",
		"placeData": "Informations de contrat",
		"tagGroups": "Groupes de Balises",
		"reserve": "File d'attente",
		"reserveV2": "Gestion des réservations",
		"delivery": "Livraison",
		"deliveryOrders": "Commandes",
		"deliveryReport": "Rapports",
		"deliveryMenus": "Menus",
		"deliveryOrdersManager": "Gestionnaire de commandes",
		"deliveryIntegrations": "Intégrations",
		"deliverySettings": "Paramètres",
		"events": "Événements",
		"extract": "Extract",
		"financialReport": "Rapports financiers",
		"guestList": "Liste d'invités",
		"invoices": "Factures",
		"transferReport": "Rapport de transfert",
		"multivendor": "Multi-vendeur",
		"passwordCard": "Carte de mot de passe",
		"pos": "Ventes POS",
		"precharge": "Sites de préchargement",
		"products": "Produits",
		"menu": "Menu",
		"bars": "Bars et secteurs",
		"opened": "Ouvert",
		"closed": "Fermé",
		"crm": "CRM",
		"reports": "Rapports",
		"preChargeLabel": "Pré-charge",
		"inventoryControl": "Contrôle de l'inventaire",
		"receptive": "Réceptif",
		"promotions": "Bonus, promotions et réductions",
		"settings": "Paramètres",
		"storage": "Stockage",
		"tickets": "Tickets",
		"ticketsReport": "Rapports Ticket",
		"whatsup": "Quoi de neuf ??",
		"zigAccount": "Compte ZIG",
		"rechargeManagement": "Gestion du solde",
		"financialFile": "Fichier financier",
		"tableReports": "Rapports de tables",
		"generalConfig": "Configuration Générale",
		"operationReport": "Rapport d'opération",
		"config": "Paramètres",
		"kds": "Gestionnaire de commandes (KDS)",
		"tableMap": "Carte des tables",
		"tableMapAttendanceManagement": "Gestion des services",
		"kdsConfig": "Gérer KDS",
		"kdsReport": "Rapport de production",
		"storageReports": "Rapports boursiers",
		"hawkersReport": "Rapport sur les ambulants",
		"catering": "Catering",
		"wizardSummary": "Résumé de l'assistant",
		"paymentLinks": "Liens de paiement"
	}
}
